import styled, { css } from 'styled-components';
import HideableBox from '@prisjakt/ui-hideable-box';
import ArrowDownIcon from 'mdi-react/ChevronDownIcon';
import { ThemeType } from '@prisjakt/ui-base/styles/themes/default';
import { Grow, Variant } from './types';

const borderSize = 1;

const dropdownBorder = (
  props: { theme: ThemeType } & SharedProps,
  transparent: boolean = false
) => {
  return `${borderSize}px solid ${
    transparent
      ? 'transparent'
      : props.theme.dropdowns[props.variant].borderColor.active
  }`;
};

export const sharedButtonStyles = {
  cursor: 'pointer',
};

interface SharedProps {
  expanded: boolean;
  variant: Variant;
}

interface ToggleButtonProps {}
export const ToggleButton = styled.button<ToggleButtonProps>``;

interface DropdownProps extends SharedProps {}
export const Dropdown = styled.div<DropdownProps>`
  position: relative;
  border: ${p => dropdownBorder(p)};
  border-bottom: ${p =>
    p.expanded && p.variant === 'primary'
      ? dropdownBorder(p, true)
      : dropdownBorder(p)};
  border-top-left-radius: ${p => p.theme.dropdowns[p.variant].borderRadius};
  border-top-right-radius: ${p => p.theme.dropdowns[p.variant].borderRadius};
  border-bottom-left-radius: ${p =>
    p.expanded ? 0 : p.theme.dropdowns[p.variant].borderRadius};
  border-bottom-right-radius: ${p =>
    p.expanded ? 0 : p.theme.dropdowns[p.variant].borderRadius};

  color: ${p => p.theme.icons.tertiary};

  ${p =>
    p.variant === 'secondary' &&
    css`
      svg,
      path {
        fill: currentColor;
      }

      border-color: transparent;

      &:hover {
        & > button {
          color: ${p.theme.icons.callToAction};
        }
      }

      & > button {
        color: ${p.expanded ? p.theme.icons.callToAction : 'inherit'};
      }
    `};

  ${p =>
    p.variant !== 'secondary' &&
    css`
      border-color: ${p.expanded
        ? p.theme.dropdowns[p.variant].borderColor.active
        : p.theme.dropdowns[p.variant].borderColor.inactive};

      background: ${p.expanded
        ? p.theme.dropdowns[p.variant].bg
        : 'transparent'};
    `};
`;

interface DropdownContentProps extends SharedProps {
  grow: Grow;
}
export const DropdownContent = styled(HideableBox)<DropdownContentProps>`
  display: block; /* display flex + absolute position breaks in IE11 */
  position: absolute;
  border: ${p => dropdownBorder(p)};
  border-top: ${p =>
    p.expanded && p.variant === 'primary'
      ? dropdownBorder(p, true)
      : dropdownBorder(p)};
  background: ${p => p.theme.dropdowns[p.variant].bg};
  border-top-left-radius: ${p =>
    p.expanded ? 0 : p.theme.dropdowns[p.variant].borderRadius};
  border-top-right-radius: ${p =>
    p.expanded ? 0 : p.theme.dropdowns[p.variant].borderRadius};
  border-bottom-left-radius: ${p => p.theme.dropdowns[p.variant].borderRadius};
  border-bottom-right-radius: ${p => p.theme.dropdowns[p.variant].borderRadius};
  z-index: 11;

  ${p =>
    p.grow === 'right' &&
    css`
      top: 100%;
      left: -${borderSize}px;
    `};

  ${p =>
    p.grow === 'left' &&
    css`
      top: 100%;
      right: -${borderSize}px;
    `};

  ${p =>
    p.grow === 'none' &&
    css`
      top: 100%;
      left: -${borderSize}px;
      right: -${borderSize}px;
    `};
`;

const arrowStyles = css`
  margin-left: auto;
`;

type ArrowProps = {
  expanded: number;
};
export const Arrow = styled(ArrowDownIcon)<ArrowProps>`
  ${arrowStyles}

  transform: ${p => (p.expanded ? 'rotate(180deg)' : 'rotate(0)')} ;
`;
